import React, {useImperativeHandle, useState, forwardRef, useEffect} from "react";


/* Props
*  label        : string
*  inputId      : string, to identify input and link it to its label
*  isReadOnly   : bool, set to true if input shouldn't be modified
*  options      : array that contains response options [{label:"Yes"}]
*/
const InputRadio = forwardRef( function InputRadio({label, options, inputId, isRequired, isReadOnly=false, defaultValue=""}, ref) {
    const [value, setValue] = useState(defaultValue);
    const [isDisplayErrors, setIsDisplayErrors] = useState(false);
        
    useImperativeHandle(ref, ()=>({
        getValue() {
            return value;
        },
        hasErrors() {
            return hasErrors();
        },
        displayErrors() {
            setIsDisplayErrors(false)
            if (hasErrors()) {
                setIsDisplayErrors(true)
            }
        },
        setValue(val) {
            setValue(val);
        },
        resetValue() {
            setValue("");  
            setIsDisplayErrors(false);         
        }
    }));
    
    useEffect(() => {
        setValue(defaultValue);
    }, [defaultValue]);

    /**
     * Check if there is an error in this input
     */
    function hasErrors() {
        return (
            isRequired && value === ""
        );
    }

    function displayErrorMessage() {
        if (isDisplayErrors) {
            return (
                <p className="input-error-message">Ce champ est obligatoire</p>
            )
        }
    }
    
    function displayOption(option, i) {        
        return (
            <div className="form-check" key={`${inputId}-${i}`}>
                <input 
                    className="form-check-input" 
                    value={option.value}                    
                    type="radio" 
                    name={inputId} 
                    id={`${inputId}-${i}`} 
                    disabled={isReadOnly}
                    checked={String(value) === String(option.value)}
                    onChange={e => setValue(e.target.value)}
                />
                <label className="form-check-label custom-form-label" htmlFor={`${inputId}-${i}`}>
                    {option.label}
                </label>
            </div>
        );
    }

    let mandatoryMark = isRequired ? "(obligatoire)" : "";

    return (
        <div className="input-checkbox mb-3">
            <label className="custom-form-label">{label} {mandatoryMark}</label>
            {options.map((option, i) => displayOption(option, i))}
            {displayErrorMessage()}
        </div>
    )
})

export default InputRadio;